import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	selectPlaceholder: {
		id: 'servicedesk-settings-virtual-agent-common.request-type-select.select-placeholder',
		defaultMessage: 'Select a request type',
		description: 'Placeholder for field that enables selection of a request type',
	},
	noMatches: {
		id: 'servicedesk-settings-virtual-agent-common.request-type-select.no-matches',
		// eslint-disable-next-line @atlassian/tangerine/i18n/messages-are-spelled-correctly
		defaultMessage: "No matches for ''{inputValue}''",
		description: 'Select menu message. Shows there is no matching request types found',
	},
});
